import script from "./Form6Page.vue?vue&type=script&setup=true&lang=js"
export * from "./Form6Page.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__